import { createFileRoute } from '@tanstack/react-router';
import { TriggerContentPage } from '@/pages/triggers/TriggerContentPage';

interface Search {
  persona_id?: string;
}

export const Route = createFileRoute('/triggers/content')({
  validateSearch: (s: Record<string, unknown>): Search =>
    typeof s.persona_id === 'string' ? { persona_id: s.persona_id } : {},
  component: TriggerContentRoute,
});

function TriggerContentRoute() {
  const search = Route.useSearch();
  return search.persona_id ? (
    <TriggerContentPage initialPersonaId={search.persona_id} />
  ) : (
    <TriggerContentPage />
  );
}
